import { render, staticRenderFns } from "./SourceObject.vue?vue&type=template&id=3f087577&scoped=true&"
import script from "./SourceObject.vue?vue&type=script&lang=ts&"
export * from "./SourceObject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f087577",
  null
  
)

export default component.exports